var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopNav'),_c('Gap',{attrs:{"xs":45}}),_c('router-view'),_c('BtmNav'),_c('a-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }